export const InputVariant = {
  default: "default",
  search: "search",
  oneWord: "oneWord",
};

export const InputSize = {
  small: "sm",
};
